import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../../Loner";
import {gsap} from "gsap"
import {LonerGameMode} from "../../../server/LonerGameMode";
import {PinTheWinFeatureObj} from "../../../server/LonerData";
import {MAIN_FG_ANIMATION_NAMES} from "../../../view/general/LonerForegroundView";
import Timeout = NodeJS.Timeout;

export class LonerPinTheWinResultPresentation implements SimplePresentation {
    private static _subTlAddedToMainTlFlag: boolean;
    private static _setTimeoutId: Timeout | null = null
    private _mainTl: gsap.core.Timeline = gsap.timeline();
    private _nextTl: gsap.core.Timeline | null = null;

    constructor() {
    }

    private static clearInterval(): void {
        if (LonerPinTheWinResultPresentation._setTimeoutId) {
            clearInterval(LonerPinTheWinResultPresentation._setTimeoutId);
            LonerPinTheWinResultPresentation._setTimeoutId = null;
        }
    }

    public static setSubTlAddedToMainTlFlag(val: boolean): void {
        LonerPinTheWinResultPresentation._subTlAddedToMainTlFlag = val;
        this.clearInterval();
    }

    shouldRun(): boolean {
        return true;
    }

    start(controller: SimplePresentationRunnerController): void {

        const pinTheWinFeatureObj: PinTheWinFeatureObj = JSON.parse(JSON.stringify(Loner.model.pinTheWinFeatureObj)),
            winMultiplier: number = Loner.model.winMultiplier,
            mode: string = Loner.model.mode,
            nextMode: string = Loner.model.nextMode,
            accumulatedRoundWin: number = Loner.model.accumulatedRoundWin,
            playedBetWin: number = Loner.model.playedBetValue;

        if (mode === LonerGameMode.NORMAL && nextMode === LonerGameMode.FEATURE_PIN_THE_WIN) {
            this.finishControllerCallback(controller);
            return
        }

        let tl: gsap.core.Timeline;
        tl = gsap.timeline({
            paused: true,
            onComplete: () => {
                LonerPinTheWinResultPresentation.clearInterval();
                if (this._nextTl) {
                    this._mainTl.clear(true);
                    this._mainTl.add(this._nextTl.play());
                    this._nextTl = null;
                } else {
                    LonerPinTheWinResultPresentation._setTimeoutId = setInterval(() => {
                        if (this._nextTl) {
                            this._mainTl.clear(true);
                            this._mainTl.add(this._nextTl.play());
                            this._nextTl = null;
                            LonerPinTheWinResultPresentation.clearInterval();
                        }
                    }, 200);
                }
            }
        });

        tl.addLabel(String(pinTheWinFeatureObj.spinsPlayed));

        tl.add(Loner.pinTheWinMainView.setAllCornerMulti(false));
        //making pin and multipliers visible
        if (Loner.pinTheWinMainView.isRestore) {
            Loner.pinTheWinMainView.setVhsMulti(winMultiplier);
            tl.add([
                Loner.pinTheWinMainView.showCornerMultipliers(0.001),
                Loner.pinTheWinMainView.setPinPosAndVisibility(pinTheWinFeatureObj.retorePos![0], pinTheWinFeatureObj.retorePos![1], true, 0.001),
                Loner.pinTheWinMainView.showVhsMulti(0.001),
                Loner.pinTheWinMainView.showHideBg(true, 0.001),
                Loner.foregroundView.playAnimationByName(MAIN_FG_ANIMATION_NAMES.PTW_GAME_LOOP, true, 2)
            ]);
            tl.to(this, 0.3, {});
        } else {
            if (pinTheWinFeatureObj.spinsPlayed === 1) {
                tl.add([
                    Loner.pinTheWinMainView.setPinPosAndVisibility(2, 2, true, 0.5),
                    Loner.pinTheWinMainView.showCornerMultipliers(0.5),
                    Loner.pinTheWinMainView.showVhsMulti(0.5),
                    Loner.pinTheWinMainView.showHideBg(true, 0.5),
                    Loner.foregroundView.playAnimationByName(MAIN_FG_ANIMATION_NAMES.PTW_GAME_LOOP, true, 2)
                ]);
            }
        }

        if (pinTheWinFeatureObj && pinTheWinFeatureObj.startMovementFlag) {
            if (pinTheWinFeatureObj.destReelId !== undefined && pinTheWinFeatureObj.destSymId !== undefined) {
                tl.add(Loner.pinTheWinMainView.movePin(pinTheWinFeatureObj.destReelId, pinTheWinFeatureObj.destSymId, {
                    mode: mode,
                    nextMode: nextMode,
                    winRatio: accumulatedRoundWin / playedBetWin,
                    nextWinMulti: (mode === LonerGameMode.FEATURE_PIN_THE_WIN && nextMode === LonerGameMode.NORMAL) ? winMultiplier : pinTheWinFeatureObj.nextWinMulti,
                    isRestore: Loner.pinTheWinMainView.isRestore,
                    trailRestorePos: Loner.pinTheWinMainView.isRestore ? [pinTheWinFeatureObj.retorePos![0], pinTheWinFeatureObj.retorePos![1]] : [2, 2],
                    spinPlayed: pinTheWinFeatureObj.spinsPlayed ? pinTheWinFeatureObj.spinsPlayed : -1
                }));
                if (pinTheWinFeatureObj.nextWinMulti) {
                    tl.add(Loner.pinTheWinMainView.setVhsMulti((mode === LonerGameMode.FEATURE_PIN_THE_WIN && nextMode === LonerGameMode.NORMAL) ? winMultiplier : pinTheWinFeatureObj.nextWinMulti));
                }
                tl.add(Loner.pinTheWinMainView.setAllCornerMulti(true), ">");
            }
        }
        if (Loner.pinTheWinMainView.isRestore) {
            if (this._mainTl && !LonerPinTheWinResultPresentation._subTlAddedToMainTlFlag) {
                this._mainTl.add(tl.play());
                LonerPinTheWinResultPresentation._subTlAddedToMainTlFlag = true;
            }
        } else {
            if (!LonerPinTheWinResultPresentation._subTlAddedToMainTlFlag) {
                this._mainTl.add(tl.play());
                LonerPinTheWinResultPresentation._subTlAddedToMainTlFlag = true;
            } else {
                this._nextTl = tl;
            }
        }

        if (mode === LonerGameMode.FEATURE_PIN_THE_WIN && nextMode === LonerGameMode.NORMAL) {
            tl.add(() => {
                this.finishControllerCallback(controller);
                LonerPinTheWinResultPresentation.clearInterval();
            });
        } else {
            tl.add(() => {
                this.finishControllerCallback(controller);
            }, (pinTheWinFeatureObj.spinsPlayed === 1 || Loner.pinTheWinMainView.isRestore) ? tl.duration() / 1.4 : 0);
        }
        if (Loner.pinTheWinMainView.isRestore) {
            Loner.pinTheWinMainView.isRestore = false;
        }
    }

    private finishControllerCallback(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }

}